import {
  Box, Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../language/keys';
import PositionStatistics from '../../../components/PositionStatistics';

export default function StatisticsList(): JSX.Element {
  const { t: translate } = useTranslation();

  return (
    <Box sx={ { opacity: 0.5 } }>
      <Typography variant="h5">
        { translate(STRING_KEYS.HOME_PAGE.SIDE_STATISTICS.TITLE) }
      </Typography>
      <Box sx={ { mt: 3 } } >
        <PositionStatistics />
      </Box>
    </Box>
  );
}
